import { oryBasePath } from '@/constants/oryContstants';
import { FrontendApi, Configuration } from '@ory/client';

export const basePath = oryBasePath; // process.env.NEXT_PUBLIC_ORY_SDK_URL; // 'https://phoenix-oauth.nuki.io'; //

export const oryFrontendClient = new FrontendApi(
  new Configuration({
    basePath,
    baseOptions: {
      withCredentials: true,
    },
  }),
);
